import React from 'react';

const Queue = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z"
      fill="white"
    />
    <path
      d="M18 31C25.1797 31 31 25.1797 31 18C31 10.8203 25.1797 5 18 5C10.8203 5 5 10.8203 5 18C5 25.1797 10.8203 31 18 31Z"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M17.9941 9.52197V13.7611"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M17.9941 22.2394V26.4785"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M26.4725 18.0004H22.2334"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M13.7548 18.0004H9.51562"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M23.9839 12.0088L20.9883 15.0044"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M14.9976 20.9958L12.002 23.9915"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M23.9839 23.9915L20.9883 20.9958"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M14.9976 15.0044L12.002 12.0088"
      stroke="#3448FF"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Queue;
